import { useState } from 'react';
import Footer from 'src/Components/Footer';

import { Outlet } from 'react-router-dom';

type Props = { 
  error?: string,
  message?: string,
  fixedFooter?: boolean,
  children: React.ReactNode, 
};

function MainPageTemplate() {

  const [isAboutOpen, setIsAboutOpen] = useState(false);
  
  const toggleAbout = () => {
    setIsAboutOpen(!isAboutOpen);
  }

  // TODO RENEE: Styles for these divs
  return (
    <div style={{display:'flex', flexDirection:'column', minHeight:'100vh'}}>
      <div style={{flex:1}}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );  
}

export default MainPageTemplate;